import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setVisible(true), 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 bg-opacity-95 text-white p-4 z-50 shadow-lg">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
        <div className="mb-4 md:mb-0 md:max-w-2xl">
          <p className="text-sm md:text-base">
            Utilizamos cookies esenciales y analíticas para mejorar tu experiencia. 
            Al continuar navegando, aceptas nuestro uso de cookies según nuestra{' '}
            <a href="/cookies" className="text-[#00bff2] hover:underline">
              política de cookies
            </a>.
          </p>
        </div>
        <div className="flex space-x-3">
          <button
            onClick={rejectCookies}
            className="px-3 py-2 text-sm border border-gray-400 rounded hover:bg-gray-700 transition-colors"
          >
            Rechazar
          </button>
          <button
            onClick={acceptCookies}
            className="px-3 py-2 text-sm bg-[#007dc6] rounded hover:bg-[#009bc9] transition-colors"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;